import { Slot } from '@radix-ui/react-slot';

import type { FC } from 'react';

import { cn } from '@/lib/utils';
import { IconSpinner } from 'icons';

import type { TButtonProps } from './Button.props';

import { buttonVariants } from './Button.variants';

const SPINNER_SIZE = 14;

const Button: FC<TButtonProps> = ({
  variant, size, asChild = false, isLoading = false, type = 'button', disabled, className, children, ...rest
}) => {
  const Component = asChild ? Slot : 'button';
  const isBusy = !asChild && isLoading;

  const content = asChild ? children : (
    <>
      {isBusy && (
        <IconSpinner aria-hidden size={SPINNER_SIZE} className="animate-spin" />
      )}
      {children}
    </>
  );

  return (
    <Component
      className={cn(buttonVariants({ variant, size }), className)}
      {...(asChild ? {} : { type })}
      disabled={disabled || isBusy}
      aria-busy={isBusy || undefined}
      {...rest}
    >
      {content}
    </Component>
  );
};

export {
  Button,
};
